export default __webpack_public_path__ + "static/media/baptiste-immortality.27b9af85.mp3";